import React from 'react';
import { func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BONUS_PRICE } from '../../constants/defaults';

const HomeSignUpv2 = ({ openSignupModal, showLeftSection = 'true' }) => {
  const { t, i18n } = useTranslation();
  let lang = i18n.language;

  return (
    <div className="HomeSignUpContainer">
      <div className="HomeSignUpContent">
        {showLeftSection && (
          <div className="LeftSection">
            <div className="offerList">
              <span className="icon">
                <LazyLoadImage
                  src="/content/images/bg/loyalty-accent-mark.svg"
                  height="16px"
                  width="17px"
                  alt=""
                />
              </span>
              <p>
                {t('Extra text')}{' '}
                <span> {t('bonusPrice', { bonusPrice: BONUS_PRICE })}</span>{' '}
                {t('your next prescription')}
              </p>
            </div>
            {_.isEqual(lang, 'en') && (
              <div className="offerList">
                <span className="icon">
                  <LazyLoadImage
                    src="/content/images/bg/loyalty-accent-mark.svg"
                    height="16px"
                    width="17px"
                    alt=""
                  />
                </span>
                <p>Earn rewards for filling prescriptions</p>
              </div>
            )}
            <div className="offerList offerListMargin">
              <span className="icon">
                <LazyLoadImage
                  src="/content/images/bg/loyalty-accent-mark.svg"
                  height="16px"
                  width="17px"
                  alt=""
                />
              </span>
              <p>{t('Extra discounts just for members')}</p>
            </div>
            <div className="leftSectionButton">
              <button
                onClick={() => openSignupModal()}
                className="signup-padding-button button whiteFocus"
              >
                {t('Sign up for free text')}
              </button>
            </div>
            <label>{t('exclusions apply')}</label>
          </div>
        )}
        <div className="RightSection">
          <div className="signUpHeader mobile-only">{t('SIGN UP TODAY!')} </div>
          <h2 className="signupHeading">
            {_.isEqual(lang, 'en') && (
              <span className="signupTextForDesktop">
                {showLeftSection
                  ? `Sign up free to get the lowest prices`
                  : `Members get our lowest prices`}
              </span>
            )}
            <div className="signupText">
              <span>
                {showLeftSection ? t('Sign up free to get') : 'Members get our'}
                <br className="mobile-only" />
              </span>
              <span className="pricesText">{t('lowest prices text')}</span>
            </div>
            <span className="noFeesText">
              {t('No monthly fees. No cost. No catch')}
            </span>
          </h2>
          <button
            onClick={() => openSignupModal()}
            className="signup-padding-button button pink whiteFocus"
          >
            {t('Sign up for free text')}
          </button>
        </div>
      </div>
    </div>
  );
};

HomeSignUpv2.propTypes = {
  openSignupModal: func
};

HomeSignUpv2.defaultProps = {
  openSignupModal: () => {}
};

export default HomeSignUpv2;
